
import React, { useState } from "react";
import UserData from "../Components/Auth/UserData";


const Context = React.createContext({});



export function ContextSidebarProvider({ children }: any) {
  let userData:any = UserData()
 
  if (!window.localStorage.getItem("userNombre")) {
    
    if(userData?.Nombre === undefined){
      console.log("docs",userData)
    
    }
    else{
       window.localStorage.setItem("emailUser",userData.Email)
       window.localStorage.setItem("userNombre",userData.Nombre)
     window.localStorage.setItem("userApellidos",userData.Apellidos)
      window.localStorage.setItem("userId",userData.UserId)
      window.localStorage.setItem("foto",userData.Foto)
       console.log("hola mi perro")
      
    }
  }
  
  const [position, setPosition] = useState(false);
  
  
  return (
    <Context.Provider value={{ position, setPosition, userData }}>
      {children}
    </Context.Provider>
  );
}

export default Context;
